import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-section">
            <div className="footer-logo">
              <span className="footer-logo-text">SYNA</span>
              <span className="footer-tagline">Structuration Opérationnelle</span>
            </div>
            <p className="footer-description">
              Transformez le chaos opérationnel en machine fluide. 
              Nous structurons votre entreprise pour une croissance durable.
            </p>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Nos Piliers</h3>
            <ul className="footer-links">
              <li><Link to="/#canal-client">Canal Client</Link></li>
              <li><Link to="/#moteur-equipe">Moteur Équipe</Link></li>
              <li><Link to="/#pilotage">Pilotage</Link></li>
              <li><Link to="/#facturation">Facturation Fluide</Link></li>
              <li><Link to="/#pack-360">SYNA 360°</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Navigation</h3>
            <ul className="footer-links">
              <li><Link to="/">Accueil</Link></li>
              <li><Link to="/about">À propos</Link></li>
              <li><Link to="/blog">Ressources</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Contact</h3>
            <ul className="footer-contacts">
              <li>
                <Mail size={18} />
                <a href="mailto:contact@synaprocess.fr">contact@synaprocess.fr</a>
              </li>
              <li>
                <Phone size={18} />
                <a href="tel:+33658448125">06 58 44 81 25</a>
              </li>
              <li>
                <MapPin size={18} />
                <span>Paris, France</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} SYNA. Tous droits réservés.
          </p>
          <div className="footer-legal">
            <Link to="/legal">Mentions légales</Link>
            <span className="separator">•</span>
            <Link to="/privacy">Politique de confidentialité</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;